import { Input } from 'reactstrap'
import { IInfoGoOrg } from '../../../types/infogo'
import useAuth from '../../../hook/useAuth'
import { CheckMarkIcon, CancelIcon } from '../../common/icons'

type OrgItemProps = {
    id: any
    org: IInfoGoOrg
    suppressed: boolean
    onSuppressCheck: (event: any) => void
}

const OrgItem = (props: OrgItemProps) => {
    const { id, org, suppressed, onSuppressCheck } = props
    const { isAdmin,isFrenchTranslator } = useAuth();
    return (
        <tr>
            <td>{org.orgName}</td>
            <td>{org.createDate}</td>
            <td>
               {!isFrenchTranslator && 
               <Input type="checkbox"
               aria-label="suppress"
               checked={suppressed}
               onChange={onSuppressCheck}
           />
               } 
               {
                isFrenchTranslator && <>
                {suppressed? <CheckMarkIcon></CheckMarkIcon>: <CancelIcon></CancelIcon>}
                </>
               }
            </td>
        </tr>
    )
}

export default OrgItem
